<template>
  <div class="text-start bg-white text-start ">
    <div class="font-semibold uppercase mb-4 text-gray-600">{{ title }}</div>

    <div class="my-3">
      <label class="">Networks</label>
      <multiselect v-model="filters.venues" placeholder="Networks" :multiple="true"
                   track-by="id" :options="venues" label="name"
                   :taggable="true"/>
    </div>
    <div class="my-3">
      <label class="">Access Points</label>
      <multiselect v-model="filters.accessPoints" placeholder="Access Points" :multiple="true"
                   track-by="id" :options="accessPoints" label="name"
                   :taggable="true"/>
    </div>
    <div class="my-3 grid md:grid-cols-3 md:gap-4" style="z-index: 0">
      <div>
        <label class="">Filter By Dates?</label>
        <select :class="inputClass" class="bg-transparent" v-model="filters.byDate">
          <option value="YES">YES</option>
          <option value="NO">NO</option>
        </select>
      </div>
      <div class="col-span-2">
        <label class="">Connection Dates</label>
        <date-range-picker :disabled="filters.byDate === 'NO'"
                           ref="dateRange"
                           v-model="filters.dateRange"
                           :opens="picker.opens"
                           :locale-data="picker.locale"
                           :minDate="picker.minDate"
                           :maxDate="picker.maxDate"
                           :singleDatePicker="picker.singleDatePicker"
                           :timePicker="picker.timePicker"
                           :timePicker24Hour="picker.timePicker24Hour"
                           :showWeekNumbers="picker.showWeekNumbers"
                           :showDropdowns="picker.showDropdowns"
                           :autoApply="picker.autoApply"
                           :linkedCalendars="picker.linkedCalendars"
                           :dateFormat="picker.dateFormat">
        </date-range-picker>
      </div>
    </div>
    <div class="mt-3">
      <label class="">Profile Filters</label>
    </div>
    <div class="mt-3 grid grid-cols-3 gap-4">
      <div class="grid grid-cols-3 gap-4">
        <select :class="inputClass" class="bg-transparent" v-model="filter.condition">
          <option value="AND">AND</option>
          <option value="OR">OR</option>
        </select>
        <select :class="inputClass" class="bg-transparent col-span-2" v-model="filter.field">
          <option v-for="(eq, i) in fields" :key="i" :value="i">{{ eq }}</option>
        </select>
      </div>
      <div class="">
        <select :class="inputClass" class="bg-transparent" v-model="filter.equation">
          <option v-for="(eq, i) in equations" :key="i" :value="i">{{ eq }}</option>
        </select>
      </div>
      <div class="flex">
        <input aria-label="Group name" type="text" required v-model="filter.value" :class="inputClass"
               placeholder="Filter Value"/>
        <div>
          <button type="submit" v-on:click="addFilter"
                  class="py-2 px-4 uppercase bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
            +
          </button>
        </div>
      </div>
    </div>
    <div class="mt-5 grid grid-cols-3 gap-4" v-for="(item, i) in filters.profile" :key="i">
      <div class="grid grid-cols-3 gap-4">
        <input aria-label="Group name" type="text" disabled v-model="item.condition" :class="inputClass"
               class="bg-gray-200"/>
        <input aria-label="Group name" type="text" disabled v-model="fields[item.field]" :class="inputClass"
               class="bg-gray-200 col-span-2"/>
      </div>
      <div class="">
        <input aria-label="Group name" type="text" disabled v-model="equations[item.equation]" :class="inputClass"
               class="bg-gray-200" placeholder="Filter Value"/>
      </div>
      <div class="flex">
        <input aria-label="Group name" type="text" disabled v-model="item.value" :class="inputClass"
               class="bg-gray-200" placeholder="Filter Value"/>
        <div>
          <button type="submit" v-on:click="removeFilter(i)"
                  class="py-2 px-4 uppercase bg-red-500 hover:bg-red-700 font-semibold text-white hover:border-transparent rounded">
            -
          </button>
        </div>
      </div>
    </div>

    <div class="mt-6 text-right">
      <button type="submit" v-on:click="saveRecord"
              class="py-2 px-4 uppercase bg-teal-500 hover:bg-teal-700 font-semibold text-white hover:border-transparent rounded">
        Save
      </button>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";

export default {
  name: "GroupFiltersComponent",
  components: {DateRangePicker},
  data() {
    return {
      name: null,
      record: {},
      filter: {
        field: 'name',
        equation: "eq",
        condition: "AND",
        value: "",
      },
      fields: {
        "name": "Name",
        "firstName": "First Name",
        "middleName": "Middle Name",
        "lastName": "Last Name",
        "phoneNumber": "Phone Number",
        "emailAddress": "Email Address",
        "facebook": "Facebook",
        "twitter": "Twitter",
        "days": "Days connected",
        "connections": "Total connections",
      },
      equations: {
        "eq": "Equals",
        "moreThan": "More Than",
        "lessThan": "Less than",
        "neq": "Not equal to",
        "empty": "Is empty",
        "notEmpty": " is not empty",
        "startsWith": "Starts with",
        "endsWith": "Ends with",
        "like": "Contains",
        "notLike": "Does not contain"
      },
      description: '',
      errors: [],
      venues: [],
      accessPoints: [],
      filters: {
        byDate: "NO",
        connections: null,
        days: null,
        dateRange: {startDate: moment().startOf("day").toDate(), endDate: moment().endOf("day").toDate()},
        venues: [],
        accessPoints: [],
        profile: [],
      },
      picker: {
        opens: "right",
        timePicker: false,
        autoApply: false,
        linkedCalendars: true,
        maxDate: moment(moment.now()).format("YYYY-MM-DD"),
        locale: {
          format: 'dd/mm/yyyy',
          direction: "ltr", //direction of text format: "DD-MM-YYYY", //format of the dates displayed
          separator: " - ", //separator between the two ranges
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
          monthNames: moment.monthsShort(), //array of month names - see moment documentions for details
          firstDay: 1 //ISO first day of week - see moment documenations for details
        }
      },
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'

    }
  },
  mounted() {
    GraphQl.sendRequest('{customerGroup(id:"' + this.id + '"){name filters description id}}')
        .then(response => {
          this.record = response.customerGroup;
          if (response.customerGroup.filters)
            this.filters = JSON.parse(unescape(response.customerGroup.filters));
        })
    GraphQl.sendRequest("{venues{id name}}")
        .then(response => {
              this.venues = response.venues;
            }
        )
    GraphQl.sendRequest("{accessPoints{id name}}")
        .then(response => {
              this.accessPoints = response.accessPoints;
            }
        )
  },
  props: {
    breadcrumb: {type: Boolean, default: true},
    title: {type: String, default: "Filters"},
    id: {type: String, required: true}
  },
  methods: {
    removeFilter(i) {
      this.filters.profile.splice(i, 1)
    },
    addFilter() {
      this.filters.profile.push(Object.assign({}, this.filter))
    },
    saveRecord() {
      let params = 'id: "' + this.id + '",' +
          'filters: "' + escape(JSON.stringify(this.filters)) + '"';

      GraphQl.sendRequest('mutation{updateCustomerGroupFilters(' + params + '){code message recordId}}')
          .then(response => {
            this.$root.$emit(response.updateCustomerGroupFilters.code === 200 ? 'alert_success' : 'alert_error', [response.updateCustomerGroupFilters.message]);
          })
          .finally(() => {
          })
    }
  }
}
</script>

<style>
.vue-daterange-picker {
  height: 100%;
}

input:checked + svg {
  display: block;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #ffffff !important;
  background-clip: padding-box;
  border: 1px solid #e8e8e8 !important;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}


.reportrange-text {
  width: 100%;
  /*height: 100%;*/
  padding: 10px 10px 8px 10px !important;
}

.vue-daterange-picker {
  width: 100%;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}


.row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}


.btn-success {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;
}

.btn-success:hover {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
}

.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: #218838;
  border-color: #1e7e34;
  box-shadow: 0 0 0 0.2rem rgba(72, 180, 97, 0.5);
}


</style>